import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { useFieldControl } from "./Field.js";
const Input = React.forwardRef(function Input2(props, ref) {
  const { className, ...rest } = useFieldControl(props);
  return /* @__PURE__ */ jsx("input", { ref, className: cx("ev-input", className), ...rest });
});
Input.displayName = "Input";
export {
  Input
};
//# sourceMappingURL=Input.js.map
